<template>
    <div class="leftConB">
        <monitor-left-radar></monitor-left-radar>
        <monitor-left-map></monitor-left-map>
    </div>
</template>

<script>
import MonitorLeftRadar from './MonitorLeftRadar'
import MonitorLeftMap from './MonitorLeftMap'

export default {
    name: 'MonitorLeftB',
    components: {
        MonitorLeftRadar,
        MonitorLeftMap,
    },
    data() {
        return {}
    },

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/monitor/partials/MonitorLeftB.vue